const config = (window as any)._app_;
const AppConfig = {
    defaultLoadDataTimeout: config.LOAD_DATA_TIMEOUT,
    defaultLoadDataInterval: config.LOAD_DATA_INTERVAL,
    pagePathToIcon: config.PAGE_PATH_TO_ICON_PAIRS,
    calculationAllSteps: config.CALCULATION_ALL_STEPS,
    backgroundColorMain: config.BACKGROUND_COLOR_MAIN,
};
export default AppConfig;